// import { I18n } from "@aws-amplify/core";
import { get } from "lodash";

import { walkInOut, driveInOut } from "../constants/reducers";
import { human, driver, truck, trailer1 } from "../constants/common";

import { formatDate } from "../utils/date";

export const copyTextToClipboard = (text, dialogElement = null) => {
  let textArea = document.createElement("textarea");

  textArea.style.position = "fixed";
  textArea.style.top = 0;
  textArea.style.left = 0;

  textArea.style.width = "2em";
  textArea.style.height = "2em";

  textArea.style.padding = 0;

  textArea.style.border = "none";
  textArea.style.outline = "none";
  textArea.style.boxShadow = "none";

  textArea.style.background = "transparent";

  textArea.innerHTML = text;

  if (dialogElement) {
    let dialog = document.getElementById(dialogElement);
    dialog.appendChild(textArea);
  } else {
    document.body.appendChild(textArea);
  }
  textArea.focus();
  textArea.select();

  try {
    document.execCommand("copy");
    //alert(I18n.get("common_textCopiedToClipboard"));
  } catch (err) {
    console.log("Oops, unable to copy");
  }

  if (dialogElement) {
    let dialog = document.getElementById(dialogElement);
    dialog.removeChild(textArea);
  } else {
    document.body.removeChild(textArea);
  }
};

export const copyLogToClipboard = (log, section) => {
  let text = "";
  text += `${get(log, ["complete", "id"])},`;
  text += `"${get(log, ["main", "zone"])}",`;
  text += `"${formatDate(
    new Date(get(log, ["main", "modifiedOn"])),
    "MM/DD/YYYY"
  )}",`;
  text += `"${formatDate(
    new Date(get(log, ["main", "modifiedOn"])),
    "hh:mm:ss A"
  )}",`;

  if (section === driveInOut) {
    text += get(log, [driver, "name"])
      ? `"${get(log, [driver, "name"])}",`
      : ",";
    text += get(log, [truck, "name"]) ? `"${get(log, [truck, "name"])}",` : ",";
    text += get(log, [trailer1, "name"])
      ? `"${get(log, [trailer1, "name"])}",`
      : ",";

    text += get(log, [driver, "id"]) ? `"${get(log, [driver, "id"])}",` : ",";
    text += get(log, [truck, "id"]) ? `"${get(log, [truck, "id"])}",` : ",";
    text += get(log, [trailer1, "id"]) ? `"${get(log, [trailer1, "id"])}"` : "";
  } else if (section === walkInOut) {
    text += get(log, [human, "name"]) ? `"${get(log, [human, "name"])}",` : ",";
    text += get(log, [human, "id"]) ? `"${get(log, [human, "id"])}",` : ",";
  }

  copyTextToClipboard(text);
};
